import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { ChatWidget } from "./ChatWidget";
import { ConsultationModal } from "./ConsultationModal";
import { Reveal } from "./motion";
import { useEffect, useRef } from "react";
import { motion, useScroll, useSpring } from "framer-motion";


/* ── Scroll Progress Bar ─────────────────────────────────────── */
function ScrollBar() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 200, damping: 30 });
  return (
    <motion.div
      style={{ scaleX, transformOrigin: "left" }}
      className="fixed top-0 left-0 right-0 h-[2.5px] z-[9999] pointer-events-none"
      aria-hidden="true"
      role="progressbar"
    >
      <div className="w-full h-full"
        style={{ background: "linear-gradient(90deg, #FF5A1F, #FFB050, #FF5A1F)", backgroundSize: "200% 100%",
          animation: "energyMove 2s linear infinite",
          boxShadow: "0 0 10px rgba(255,90,31,0.7)" }} />
    </motion.div>
  );
}

export const Layout = ({ children }) => (
  <>
    <ScrollBar />
    <Navbar />
    <main>{children}</main>
    <Footer />
    <ChatWidget />
    <ConsultationModal />
  </>
);


/* Compact dark hero for inner pages */
export const PageHero = ({ eyebrow, title, sub }) => (
  <section className="section-dark relative pt-24 pb-12 sm:pt-40 sm:pb-24 px-5 sm:px-8 overflow-hidden grid-bg-dark">
    <div className="blob w-[460px] h-[460px] bg-[#FF5A1F] -top-32 -left-24 animate-aurora" style={{ opacity: 0.3 }} />
    <div className="max-w-5xl mx-auto relative z-10">
      {eyebrow && <Reveal><span className="inline-block text-[#FF5A1F] font-heading text-sm font-semibold uppercase tracking-[0.2em] mb-4">{eyebrow}</span></Reveal>}
      <Reveal delay={0.1}><h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white leading-[1.05]">{title}</h1></Reveal>
      {sub && <Reveal delay={0.2}><p className="mt-6 text-lg text-neutral-400 max-w-2xl leading-relaxed">{sub}</p></Reveal>}
    </div>
  </section>
);

export default Layout;
